// extracted by mini-css-extract-plugin
export default {"chipContainer":"Chip_chipContainer__+0eWq","green":"Chip_green__9MQLv","red":"Chip_red__l8dpb","grey":"Chip_grey__ar3An","blue":"Chip_blue__O0rEA","amber":"Chip_amber__vOAVD"};